import React from 'react';
import { useTranslation } from 'react-i18next';

import Logo from '../../elements/logo/Logo';
import Nav from './Nav';
import StickyHeader from './StickyHeader';
import SwitcherHeader from '../../elements/switcher/SwitcherHeader';
import MobileMenu from './MobileMenu';

const HeaderFour = () => {
  const sticky = StickyHeader(100);
  const { t, i18n } = useTranslation();

  const MobileMenuHandler = () => {
    const popup = document.querySelector('.mobilemenu-popup');
    const body = document.querySelector('body');
    if (popup) {
      popup.classList.toggle('show');
    }
    if (body) {
      body.classList.toggle('mobilemenu-show');
    }
  };

  const handleNavigation = () => {
    const popup = document.querySelector('.mobilemenu-popup');
    const body = document.querySelector('body');
    if (popup) {
      popup.classList.remove('show');
    }
    if (body) {
      body.classList.remove('mobilemenu-show');
    }
  };

  return (
    <>
      <header className="header axil-header header-style-4 mutawir-header">
        <div className={`axil-mainmenu ${sticky ? 'axil-sticky' : ''}`}>
          <div className="container">
            <div className="header-navbar">
              <div className="header-logo">
                <Logo />
              </div>
              <div className="header-main-nav d-none d-lg-flex">
                <Nav />
              </div>
              <div className="header-action">
                <ul className="list-unstyled">
                  <li className="d-none d-lg-inline-flex align-items-center">
                    <div className="language-toggle">
                      <button
                        type="button"
                        className={i18n.language && i18n.language.startsWith('en') ? 'is-active' : ''}
                        onClick={() => i18n.changeLanguage('en')}
                      >
                        EN
                      </button>
                      <button
                        type="button"
                        className={i18n.language === 'ar' ? 'is-active' : ''}
                        onClick={() => i18n.changeLanguage('ar')}
                      >
                        ع
                      </button>
                    </div>
                  </li>
                  <li className="my_switcher">
                    <SwitcherHeader />
                  </li>
                  <li className="header-btn d-none d-lg-inline-flex">
                    <a href={t('navigation.ctaHref')} className="axil-btn btn-fill-white">
                      {t('navigation.cta')}
                    </a>
                  </li>
                  <li className="mobile-menu-btn sidemenu-btn d-lg-none d-block">
                    <button className="btn-wrap" onClick={MobileMenuHandler} aria-label="Toggle navigation">
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
      <MobileMenu MobileHandler={MobileMenuHandler} onNavigate={handleNavigation} />
    </>
  );
};

export default HeaderFour;
